
import React from 'react';
import '../style/App.css';

const Translate = ({ text }) => {
  const [translated, setTranslated] = React.useState("");
  async function Translate() {
    if (translated !== "") {
      setTranslated("");
      return;
    }
    let fromLang = 'zh';
    let toLang = 'en';
    let url = `https://translation.googleapis.com/language/translate/v2?key=${process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY}`;
    url += '&q=' + encodeURI(text);
    url += `&source=${fromLang}`;
    url += `&target=${toLang}`;

    const data = await fetch(url, { 
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    });
    const result = await data.json();
    setTranslated(result.data.translations[0].translatedText);
  }

  return (
    <div>
      <p className="translated-text">{translated}</p>
      <p className="translated" onClick={Translate}>Translate</p>
    </div>
  );
};

export default Translate;